<div class="d-flex align-items-start w-100 h-100 overflow-auto">
    <div class="image-container w-100 h-100 d-flex align-items-center justify-content-end">
        <img src="assets/images/main.webp" alt="" width="100%" height="100%">
    </div>
    <div class="content d-flex align-items-start w-100 h-100 overflow-auto">
        <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center">
            <div class="content-container d-flex flex-column w-100 flex-grow-1 justify-content-center">
                <div class="d-flex flex-row">
                    <img src="assets/images/logo.png" alt="" height="144px">
                </div>
                @if (showTitle())
                {
                    <div class="title-wrapper d-flex flex-row align-items-center gap-2">
                        @if (showBackButton())
                        {
                            <button class="go-back" (click)="goBack($event)">
                                <svg-icon src="assets/icons/arrow-left.svg" class="back-icon" />
                            </button>
                        }
                        <h1 class="color-gray">{{title()}}</h1>
                    </div>
                }
                <ng-content></ng-content>
            </div>
            <div class="brand-wrapper d-flex justify-content-center p-20">
                <span class="body14-inter color-gray-40">By LOAD</span>
            </div>
        </div>
    </div>
</div>
